import React from 'react';

type BookingContextType = {
  booking: ArrivalBooking;
  handleTransportUpdate: (body: UpdateBookingTransportBody) => void;
  handleDateUpdate: (body: UpdateBookingDateBody) => void;
  handleUpsertParticipants: (saved: UpsertParticipantsResponse) => void;
  handleCancel: () => void;
};

const BookingContextDefaultValues: BookingContextType = {
  booking: {} as ArrivalBooking,
  handleTransportUpdate: () => {},
  handleDateUpdate: () => {},
  handleUpsertParticipants: () => {},
  handleCancel: () => {},
};

export const BookingContext = React.createContext<BookingContextType>(
  BookingContextDefaultValues
);
export const useBooking = () => React.useContext(BookingContext);
